import { render, staticRenderFns } from "./SitchPremium.vue?vue&type=template&id=1e1da80d&scoped=true&"
import script from "./SitchPremium.vue?vue&type=script&lang=ts&"
export * from "./SitchPremium.vue?vue&type=script&lang=ts&"
import style0 from "./SitchPremium.vue?vue&type=style&index=0&id=1e1da80d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1da80d",
  null
  
)

export default component.exports